import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useRegisterMutation } from 'src/api/auth';
import { companyName } from 'src/config';
import {
  validateConsent,
  validateEmail,
  validateFirstName,
  validateLastName,
  validateNewPassword,
  validatePhone,
  validateRepeatPass,
} from 'src/helpers/validators';
import { links } from 'src/router/routes';
import { RoleEnum } from 'src/types';

export type FormData = {
  first_name: string;
  last_name: string;
  email: string;
  phone_number: string;
  password: string;
  confirm_password: string;
  consent: boolean;
};

const initialValues: FormData = {
  confirm_password: '',
  consent: false,
  email: 'john.doe@example.com',
  first_name: '',
  last_name: '',
  password: '',
  phone_number: '',
};

const validate = {
  confirm_password: (value: string, { password }: { password: string }) =>
    validateRepeatPass(value, password),
  consent: (value: boolean) => validateConsent(value),
  email: (value: string) => validateEmail(value),
  first_name: (value: string) => validateFirstName(value),
  last_name: (value: string) => validateLastName(value),
  password: (value: string) => validateNewPassword(value),
  phone_number: (value: string) => validatePhone(value),
};

const param = 'token';

export const useRegister = () => {
  const { registerMutation, isPending, isSuccess } = useRegisterMutation();

  const [searchParams, setSearchParams] = useSearchParams();
  const [invitationToken, setInvitationToken] = useState<string>();
  const navigate = useNavigate();

  //TODO: get comapny id from user
  const companyId = 1;
  const title = `Welcome to ${companyName}'s Playwall`;
  const subtitle = 'Sign in';
  const role = RoleEnum.EDITOR;

  const onSubmit = (data: FormData) => {
    if (companyId && invitationToken) {
      registerMutation({
        ...data,
        company_id: companyId,
        invitation_token: invitationToken,
        role,
      });
    }
  };

  useEffect(() => {
    const token = searchParams.get(param);
    if (token && !invitationToken) {
      setInvitationToken(token);
      searchParams.delete(param);
      setSearchParams(searchParams);
    }
  }, [invitationToken, searchParams, setSearchParams]);

  useEffect(() => {
    if (isSuccess) {
      navigate(links.accountConfirmation);
    }
  }, [isSuccess, navigate]);

  return {
    initialValues,
    isLoading: isPending,
    onSubmit,
    subtitle,
    title,
    validate,
  };
};
